import { Graph } from "@antv/x6"
import { PortTypes } from "../../constant"

Graph.registerPortLayout(PortTypes.NozzlePort, (portsPositionArgs, bbox) => {
  return portsPositionArgs.map((args) => {
    const { width, height } = bbox
    let { x, y } = args
    if (x <= 1) {
      x = x * width
    }
    if (y <= 1) {
      y = y * height
    }
    return {
      position: {
        x,
        y
      },
    }
  })
})